import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getEventStatus } from "../../helper/formatCurrency";
import "./CheckoutPage.css";

const CheckoutMonnifyPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentReference = searchParams.get("paymentReference");
  const statusFromMonnify = searchParams.get("status"); // SUCCESS | CANCELLED | FAILED

  const [loading, setLoading] = useState(true);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("error");

  const event = JSON.parse(localStorage.getItem("eventData"));

  useEffect(() => {
    if (!paymentReference) return;

    if (statusFromMonnify === "CANCELLED") {
      setAlertMessage("Payment was cancelled");
      setAlertType("error");
    } else if (statusFromMonnify === "SUCCESS") {
      setAlertMessage("Payment Successful 🎉");
      setAlertType("success");
    } else {
      setAlertMessage("Payment not completed");
      setAlertType("error");
    }

    setLoading(false);
    setAlertVisible(true);
  }, [paymentReference, statusFromMonnify]);

  const handleDismiss = (action) => {
    setAlertVisible(false);

    if (action === "success") {
      navigate("/home/guest", { state: { success: true } });
    }

    if (action === "aborted") {
      navigate(`/eventManagementDetails/${event.id || event._id}`, {
        state: {
          eventTitle: event.title || event.eventName || "Event",
          eventDate: event.eventDate || event.startDate,
          eventStatus: getEventStatus(event.eventDate || event.startDate),
          eventDetails: event,
          from: `/home/guest`,
        },
      });
    }

    if (action === "retry") {
      navigate(-1);
    }
  };

  return (
    <div className="checkout-page">
      {loading && (
        <div className="checkout-loading-overlay">
          <div className="checkout-spinner"></div>
          <p>Verifying payment...</p>
        </div>
      )}

      {alertVisible && (
        <div className="checkout-alert-overlay">
          <div className={`checkout-alert ${alertType}`}>
            <div className="alert-icon">
              {alertType === "success" ? "✓" : "✕"}
            </div>

            <h2>{alertMessage}</h2>

            <div
              className={`alert-actions ${
                alertType !== "success" ? "single-row" : ""
              }`}
            >
              {alertType === "success" && (
                <button
                  onClick={() => handleDismiss("success")}
                  className="alert-dismiss-button"
                >
                  Continue
                </button>
              )}

              {alertType !== "success" && (
                <>
                  <button
                    onClick={() => handleDismiss("retry")}
                    className="alert-dismiss-button"
                  >
                    Try Again
                  </button>

                  <button
                    onClick={() => handleDismiss("aborted")}
                    className="alert-dismiss-button secondary"
                  >
                    Continue
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutMonnifyPage;
